import jQuery from 'jquery';
import _ from 'lodash';

var isTimeOutRun = true;

const DEFAULT_API_URL = '/api/internal';
var _ourClientVersion = null;
var _currentClientVersion = null;

var APIClient = {
  pageCsrfToken: pageCsrfToken,
  needsUpdate: needsUpdate,
  get: getAction,
  delete: deleteAction,
  post: postAction,
  put: putAction,
  patch: patchAction,
  baseUrl: baseUrl,
  uploadFile: uploadFile,
  startCurrentUserLongPolling,
  cancelCurrentUserLongPolling,
  _request: _request
};

function pageCsrfToken() {
  return jQuery('meta[name=csrf-token]').attr('content');
}

function needsUpdate() {
  return (
    _ourClientVersion &&
    _currentClientVersion &&
    _ourClientVersion != _currentClientVersion
  );
}

function getAction(params) {
  return this._request(_.assign(params, { method: 'GET' }));
}

function deleteAction(params) {
  return this._request(_.assign(params, { method: 'DELETE' }));
}

function postAction(params) {
  return this._request(_.assign(params, { method: 'POST' }));
}

function putAction(params) {
  return this._request(_.assign(params, { method: 'PUT' }));
}

function patchAction(params) {
  return this._request(_.assign(params, { method: 'PATCH' }));
}

function baseUrl() {
  return DEFAULT_API_URL;
}

function uploadFile(putUrl, formData, onSuccess, type = 'PUT', onError) {
  const onFail = typeof onError !== 'undefined' ? onError : function() {};

  jQuery.ajax({
    type: type,
    url: putUrl,
    data: formData,
    headers: {
      Accept: 'application/json',
      'X-CSRF-Token': this.pageCsrfToken()
    },
    cache: false,
    processData: false,
    contentType: false,
    mimeType: 'multipart/form-data',
    enctype: 'multipart/form-data',
    success: onSuccess,
    error: onFail
  });
}

function startCurrentUserLongPolling(url, onSuccess, timeout) {
  isTimeOutRun = true;
  const pageCsrfToken = this.pageCsrfToken();
  (function poll() {
    jQuery.ajax({
      type: 'GET',
      url,
      success: onSuccess,
      dataType: 'json',
      headers: { Accept: 'application/json', 'X-CSRF-Token': pageCsrfToken },
      contentType: 'application/json; charset=UTF-8',
      beforeSend: function(xhr) {
        if (!isTimeOutRun) {
          xhr.abort();
        }
      }
    });
  })();
}

function cancelCurrentUserLongPolling() {
  isTimeOutRun = false;
}

function _request(params) {
  params.data = typeof params.data !== 'undefined' ? params.data : {};
  params.success =
    typeof params.success !== 'undefined' ? params.success : function() {};
  params.error =
    typeof params.error !== 'undefined' ? params.error : function() {};
  params.beforeSend =
    typeof params.beforeSend !== 'undefined'
      ? params.beforeSend
      : function() {};
  params.complete =
    typeof params.complete !== 'undefined' ? params.complete : function() {};

  if (typeof params.method === 'undefined') {
    throw 'API Client: HTTP method required';
  }

  if (typeof params.path === 'undefined') {
    throw 'API Client: path required';
  }

  var url = params.skipApiUrl ? params.path : this.baseUrl() + params.path;
  if (params.jsonData) {
    params.data = JSON.stringify(params.jsonData);
    params.contentType = 'application/json; charset=UTF-8';
  } else {
    params.contentType = 'application/x-www-form-urlencoded; charset=UTF-8';
  }

  var headers = {
    'X-Homie-Client': true
  };

  if (params.method != 'GET') {
    headers['X-CSRF-Token'] = this.pageCsrfToken();
  }

  let ajaxParams = {
    url: url,
    type: params.method,
    data: params.data,
    contentType: params.contentType,
    headers: headers,
    success: function(data, textStatus, jqXHR) {
      const version = jqXHR.getResponseHeader('X-Homie-Client-Version');
      if (!_.isEmpty(version)) {
        if (_ourClientVersion == null) {
          _ourClientVersion = version;
          _currentClientVersion = version;
        } else {
          _currentClientVersion = version;
        }
      }
      params.success(data, textStatus, jqXHR);
    },
    error: function(jqXHR, textStatus, errorThrown) {
      if (jqXHR.status === 401 && !params.skipRedirect) {
        if (window.location.pathname !== '/h/') {
          let newLocation = `${window.location.origin}/h/autenticacion?return_to=${window.location.pathname}`;
          window.location.replace(newLocation);
        }
      } else {
        params.error(jqXHR, textStatus, errorThrown);
      }
    },
    beforeSend: function(jqXHR) {
      params.beforeSend(jqXHR);
    },
    complete: function(jqXHR) {
      params.complete(jqXHR);
    }
  };

  if (params.fileUpload) {
    ajaxParams.cache = false;
    ajaxParams.processData = false;
    ajaxParams.contentType = false;
  }

  return jQuery.ajax(ajaxParams);
}

export default APIClient;
